module.exports = __webpack_public_path__ + "img/submit-button.125a41e6.png";